import React from "react";
import { CheckCircle } from "lucide-react";
import { motion } from "framer-motion";

const AlYasminahWhy: React.FC<{ content?: any }> = ({ content }) => {
  const points = [
    content?.why_1 || "Dedicated on-site building management",
    content?.why_2 || "Transparent communication with tenants",
    content?.why_3 || "Regular maintenance and inspections",
    content?.why_4 || "Strong focus on cleanliness and safety",
    content?.why_5 || "Cost-effective operational planning",
    content?.why_6 || "Continuous improvement of standards",
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 font-sans">
      <motion.div
        className="bg-white rounded-lg shadow-lg p-6 md:p-8 border"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10">
          {content?.why_title || "Why Choose Al Yasminah?"}
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          {points.map((pt, i) => (
            <div key={i} className="flex items-center space-x-4 p-4 rounded-lg bg-red-50/50 border border-red-100/50">
              <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
              <span className="text-gray-800 font-medium">{pt}</span>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default AlYasminahWhy;
